/* Aspect Ratio Component - A component that displays an aspect ratio - from shadcn/ui (exposes AspectRatio) */
import * as AspectRatioPrimitive from '@radix-ui/react-aspect-ratio'

const AspectRatio = AspectRatioPrimitive.Root

export { AspectRatio }
